import { State } from 'xstate';
import { Division } from '@chargify/data-access';

import { addressMachine } from './address';

type AddressMachine = typeof addressMachine;

type AddressState = State<AddressMachine['context']>;

export const getCountries = (
  machineState: AddressState
): {
  items: Division[];
  isLoading: boolean;
} => ({
  items: machineState.context.countries || [],
  isLoading: machineState.matches('country.fetching'),
});

export const getSubdivisions = (
  machineState: AddressState
): {
  items: Division[];
  isLoading: boolean;
} => ({
  items: machineState.context.subdivisions || [],
  isLoading: machineState.matches('subdivision.fetching'),
});

export const addressSelectors = {
  getCountries,
  getSubdivisions,
};
